<div class="container newcontainer">
  <div class="partition2 fahion-offer-container">
    <ng-container *ngFor="let offer of ProductsOffers; let i = index">
      <div [style]="offer.width" class="banner-layout1" *ngIf="          (offer.offer_on == 'offer' ||
            offer.offer_on == 'img' ||
            offer.offer_on == 'pages_support_center_and_blog' ||
            offer.offer_on == 'services' ||
            offer.offer_on == 'trademarks' ||
            offer.offer_on == 'products' ||
            offer.offer_on == 'new' ||
            offer.offer_on == 'all_trademarks' ||
            offer.offer_on == 'best_seller' ||
            offer.offer_on == 'is_back_from_new' ||
            offer.offer_on == 'form_shapes' ||
            offer.offer_on == 'external_link' ||
            offer.offer_on == 'groups' ||
            offer.offer_on == 'coupon') &&
          ((offer.offer_end_date && offer.show_end_date == '1'  && isOfferValid(offer.offer_end_date)) || offer.img)
        ">
        <!-- offer.offer_on == 'selected_products' ||offer.offer_on == 'gallery' || in ngif -->
        <a *ngIf="offer.offer_on == 'offer' && offer.offer_id" [routerLink]="['/shop/offer/' + offer.offer_id]"
          aria-label="Go to offer">
          <div class="countdown-timer-block"
            *ngIf="offer?.offer_end_date && offer?.show_end_date == '1' && isOfferValid(offer.offer_end_date)">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="offer.offer_on == 'offer' && !offer.offer_id">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <!-- <a *ngIf="offer.offer_on == 'img'||offer.offer_on == 'gallery'||offer.offer_on == 'groups'"> -->
        <a *ngIf="offer.offer_on == 'img'">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>
        <a *ngIf="offer.offer_on == 'external_link'" [href]="offer.offer_id" target="_blank">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>

          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>
        <a *ngIf="offer.offer_on == 'selected_products' && offer.offer_id" class="cursor-pointer"
          (click)="selectedProducts(offer)" aria-label="Go to selected products">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>

          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>











        <a *ngIf="offer.offer_on == 'form_shapes'" (click)="formShape(offer)">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center cursor-pointer collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="
            offer.offer_on == 'pages_support_center_and_blog' && offer.offer_id
          " [routerLink]="[
            '/pages/support-category-page/article/' +
              offer.offer_id +
              '/' +
              offer.title.split(' ').join('-')
          ]">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>

          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>
        <a *ngIf="offer.offer_on == 'services' && offer.offer_id" [routerLink]="[
            '/shop/category/' + offer.offer_id + '/' + offer.title
          ]" aria-label="Go to services">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>

          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="offer.offer_on == 'services' && !offer.offer_id">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>

          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>
        <a *ngIf="offer.offer_on == 'trademarks' && offer.offer_id" [routerLink]="[
            '/shop/trademarkes/' +
              offer.offer_id +
              '/' +
              offer.title?.split(' ').join('-')
          ]" aria-label="Go to trademark">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>

          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="offer.offer_on == 'trademarks' && !offer.offer_id">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="offer.offer_on == 'products' && offer.offer_id" [routerLink]="[
            '/shop/product/',
            offer.offer_id,
            offer.product_title?.meta_url
              ? removeBrackets(offer.product_title.meta_url)
                  ?.split(' ')
                  .join('-')
              : removeBrackets(offer.product_title.name)?.split(' ').join('-')
          ]" aria-label="Go to product">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="offer.offer_on == 'products' && !offer.offer_id">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="offer.offer_on == 'new'" [routerLink]="['/shop/category/' + '/' + offer.offer_on]"
          aria-label="Go to new">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>
        <a *ngIf="offer.offer_on == 'all_trademarks'" [routerLink]="['/elements/trademarks/']"
          aria-label="Go to trademark">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="offer.offer_on == 'best_seller'" [routerLink]="['/shop/category/' + '/' + offer.offer_on]"
          aria-label="Go to best_seller">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="offer.offer_on == 'is_back_from_new'" [routerLink]="['/shop/category/' + '/' + offer.offer_on]"
          aria-label="Go to is_back_from_new">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>
          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>

        <a *ngIf="offer.offer_on == 'coupon'" [routerLink]="['/shop/coupon/' + offer.offer_id]"
          aria-label="Go to coupon">
          <div class="countdown-timer-block" *ngIf="offer?.offer_end_date && offer?.show_end_date == '1'">
            <app-countdown-timer [offerEndDate]="offer?.offer_end_date" [title]="offer?.title"></app-countdown-timer>
          </div>

          <div class="text-center collection-banner p-right" *ngIf="offer.img">
            <img [src]="offer.image" class="img-fluid" alt="collection-banner" (error)="
                handleImageError($event.target);
                $event.target.style.height = '150px'
              " />
          </div>
        </a>
      </div>
    </ng-container>
  </div>
</div>